import axios from 'axios';
import { useState, useEffect } from 'react';
import makeAnimated from 'react-select/animated';
import AsyncSelect from 'react-select/async';
import debounce from 'lodash.debounce';

const SearchUserByEC = ({ getSuperiorDetails, token, hodUsername, isDisabled}) => {
    const [query, setQuery] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const {REACT_APP_API_BACKEND_URL_EXIT_FORM} = process.env;


    // Get animated components wrapper
    const animatedComponents = makeAnimated();

    // Load options based on user input
    const loadOptions = async (inputValue, callback) => {
        if (!inputValue) {
            callback([]);
            return;
        }

        try {

            const url = REACT_APP_API_BACKEND_URL_EXIT_FORM + `get/hod/info/${inputValue}`;
            const res = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            const data = res.data;
            console.log(data)
            if (data && typeof data === 'object') {
                const option = {
                    label: data.fullName,
                    value: data.employee_id,
                    title: data.title,
                    username: data.username,
                    email: data.email,
                };

                callback([option]);
            } else {
                console.warn('Unexpected data format:', data);
                callback([]);
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            callback([]);
        }
    };

    const debouncedSetQuery = debounce(setQuery, 300);

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        getSuperiorDetails(selectedOption);
    };


    const fetchDefaultOption = async () => {
        if (hodUsername) {
            try {

                const url = REACT_APP_API_BACKEND_URL_EXIT_FORM+ `get/hod/info/${hodUsername}`;

                const res = await axios.get(url, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                });


                const data = res.data;
                const defaultOption = {
                    label: data.fullName,
                    value: data.userId,
                    title: data.title,
                    ...data
                };

                setSelectedOption(defaultOption);
                getSuperiorDetails(defaultOption);
            } catch (error) {
                console.error('Error fetching default option:', error);
            }
        }
    };

    useEffect(() => {
        fetchDefaultOption();
    }, [hodUsername, token]);

    return (
        // <div style={{ width: '330px', marginTop: '-25px', marginLeft: '25px' }}>
            <AsyncSelect
                isDisabled={isDisabled}
                placeholder={"Search by username..."}
                defaultOptions
                components={animatedComponents}
                loadOptions={loadOptions}
                value={selectedOption}
                onInputChange={debouncedSetQuery}
                onChange={handleChange}
                isClearable
            />
        // </div>
    );
};

export default SearchUserByEC;
